<template lang="pug">
  div.access.user-update
    e-form-modal(
    ref="modalForm"
     @submitModalForm="sendForm()"
     @deleteItem="deleteItem()"
     :hideDeleteButton="(fields.id ? true : false)"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title {{formTitle}}
        e-form-tabs(
        v-model="tabView"
        :tabs="tabs"
        )
      slot
          e-form(:formValidator="formValidator")
            // вкладка ОБЩИЕ СВЕДЕНИЯ
            div(v-show="tabView == 'tab1'").tab1
                div.body
                  div.col
                    e-form-subtitle(text="Настройки аккаунта")
                    e-form-group(
                      name="fullname"
                      inputType="input"
                      label="ФИО"
                      :model="fields"
                      tabView="tab1"
                      autocomplete="off"
                      :required="true"
                    )

                    e-form-group(
                     name="user_group_id"
                     inputType="select"
                     label="Группа "
                     :model="fields"
                     :options="roles"
                     tabView="tab1"
                     :required="true"
                    )
                    e-form-group(
                    name="username"
                    inputType="input"
                    label="Логин"
                      :model="fields"
                    tabView="tab1"
                      :required="true"
                    )
                    e-form-group(
                    name="email"
                    inputType="input"
                    label="E-mail"
                      :model="fields"
                        :required="true"
                    tabView="tab1"
                    validationRule="email"
                    )

                    //настроить пункты активен - не активен
                    e-form-group(
                    name="activated"
                    inputType="select"
                    label="Активность"
                      :model="fields"
                        :options="activeOptions"
                    tabView="tab1"
                      :required="true"
                    )


                  div.col
                    e-form-subtitle(text="Личные данные")

                    e-form-group(
                    name="department"
                    inputType="input"
                    label="Отдел"
                      :model="fields"
                    tabView="tab1"
                    )
                    e-form-group(
                    name="position"
                    inputType="input"
                    label="Должность"
                      :model="fields"
                    tabView="tab1"
                    )
                    e-form-group(
                    name="phone"
                    inputType="input"
                    label="Рабочий телефон/Skype"
                      :model="fields"
                    tabView="tab1"
                    )
                    e-form-group(
                    name="mobile_phone"
                    inputType="input"
                    label="Мобильный телефон"
                      :model="fields"
                    tabView="tab1"
                    mask="+7(###) ###-##-##"
                    )
                    e-form-group(
                    name="birth_date"
                    inputType="calendar"
                    label="Дата рождения"
                      :model="fields"
                    tabView="tab1"
                    )

                  div.col
                    div.col-block
                      div(v-if="userPhoto").image
                        img(:src="userPhoto")
                      div(v-else).image
                        img(src="~img/user-img-default.svg")

                    e-form-group(
                    name="geoRegionObjects"
                    inputType="suggestion[]"
                    label="Видимые муниципальные образования"
                    :model="fields"
                    tabView="tab1"
                    :options="mosOptions"
                    :enableSelectAll="true"
                    ).mos-selector

                    e-form-group(
                    name="geoVillageObjects"
                    inputType="suggestion[]"
                    label="Видимые сельские поселения"
                    :model="fields"
                    tabView="tab1"
                    :options="settlements"
                    :enableSelectAll="true"
                    ).mos-selector


            div(v-if="tabView == 'tab2'")
              div.body.body-table
                div.mt-40
                  e-user-files(
                  :endpoint="getFilesEndpoint"
                  :downloadFile="downloadFile"
                  )

</template>

<script>
  import {atu, access, map as mapEndpoints} from '../../api/api-endpoints.js'
  import adminForm from './mixins/admin-form.js'

  export default {
    mixins: [adminForm],
    data () {
      return {
        tabView: 'tab1',
        fields: {
          activated: 1,
          is_active: true,
          role: '',
          fullname: '',
          username: '',
          password: ''
        },
        errors: null
      }
    },
    computed: {
      tabs () {
        if (this.$route.params.id) {
          return [{tab1: 'Общие сведения'}, {tab2: 'Файлы'}]
        }
        return [{tab1: 'Общие сведения'}]
      },
      formTitle () {
        if (this.fields && this.fields.id) {
          return this.fields.fullname
        }
        return this.$translate('Добавление нового пользователя')
      }
    },
    methods: {
      update () {
        adminForm.methods.update.call(this)
        this.filterGeoObjects(this.mos, 'geoRegionObjects', this.fields.geoObjects)
        this.filterGeoObjects(this.settlements, 'geoVillageObjects', this.fields.geoObjects)
        // select all mos if list null
        // see logic in: https://redmine.etton.ru/issues/13113
        this.selectAllIfNull(this.mos, 'geoRegionObjects')
        this.selectAllIfNull(this.settlements, 'geoVillageObjects')
      },
      prepareFieldsForSend (fields = {}) {
        let fieldsDeepCopy = JSON.parse(JSON.stringify(fields))
        // if select all mos, unset it
        // see logic in: https://redmine.etton.ru/issues/13113
        this.ifSelectAllUnset(this.mos, fieldsDeepCopy.geoRegionObjects)
        this.ifSelectAllUnset(this.settlements, fieldsDeepCopy.geoVillageObjects)
        fieldsDeepCopy.geoObjects = [
          ...fieldsDeepCopy.geoRegionObjects,
          ...fieldsDeepCopy.geoVillageObjects
        ]
        return fieldsDeepCopy
      },
      getMOEndpoint () {
        return atu.atuObjects({query: {'per-page': -1}})
      },
      getSettlementEndpoint () {
        // 5 - сельские поселения
        return mapEndpoints.settlementsByType(5)
      },
      // send post for correct change status and avatar
      getStoreAction () {
        return 'createModel'
      },
      getRolesUrl () {
        return access.groups()
      },
      getDeleteUrl (id){
        return access.userDelete(id)
      },
      getUpdateOrCreateUrl() {
        return access.userUpdateOrCreate(this.$route.params.id)
      },
      getItemEndpoint(route){
        if (!route.params.id) {
          return null
        }
        return access.userById(route.params.id)
      }
    }
  }
</script>
